import React from 'react';

import { Anchor, Button, PasswordInput, Stack, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useAuth } from 'context/auth-context';
import { emailValidator } from 'utils/form-validators';

interface FormValues {
  email: string;
  password: string;
  rememberMe: boolean;
  navigateAfterLogin: boolean;
}

interface LoginProps {
  onForgotPassword: () => void;
}

const Login = ({ onForgotPassword }: LoginProps): JSX.Element => {
  const { login, isLoading } = useAuth();

  const form = useForm<FormValues>({
    initialValues: {
      email: '',
      password: '',
      rememberMe: false,
      navigateAfterLogin: false,
    },

    validate: {
      email: value => emailValidator(value),
      password: value => (value ? null : 'Required'),
    },
  });

  const handleSubmit = (formValues: FormValues): void => {
    login(formValues);
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack px='xl'>
        <TextInput
          label='Email'
          placeholder='jane@mygym.com'
          data-cy='userInput'
          required
          {...form.getInputProps('email')}
        />
        <PasswordInput
          label='Password'
          placeholder='•••••••'
          data-cy='passInput'
          required
          {...form.getInputProps('password')}
        />
        <Anchor size='sm' align='center' onClick={onForgotPassword} sx={{ cursor: 'pointer' }}>
          Forgot password?
        </Anchor>
        <Button type='submit' data-cy='loginSubmit' loading={isLoading}>
          Login
        </Button>
      </Stack>
    </form>
  );
};

export default Login;
